import { useEffect } from 'react';

export function useScrollSpy({
  itemIds,
  onActiveChange,
  offset = '0px 0px -50% 0px',
  threshold = 0.6
}: {
  itemIds: string[];
  onActiveChange: (activeIndex: number) => void;
  offset?: string;
  threshold?: number;
}) {
  useEffect(() => {
    const sections = itemIds.map(id => document.getElementById(id)).filter(Boolean) as HTMLElement[];

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting && entry.intersectionRatio >= threshold) {
            const activeId = entry.target.id;
            const activeIndex = itemIds.findIndex(id => id === activeId);

            onActiveChange(activeIndex);
          }
        });
      },
      {
        threshold: [threshold],
        rootMargin: offset
      }
    );

    sections.forEach(section => observer.observe(section));

    return () => {
      observer.disconnect();
    };
  }, [itemIds, onActiveChange, offset, threshold]);
}
